import _get from "lodash/get";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Segment } from "semantic-ui-react";
import { DocumentRequestStepPanels } from "./DocumentRequestStepPanels";
import { DocumentRequestStepsHeader } from "./DocumentRequestStepsHeader";
import { getCurrentStep } from "./Steps";

export class DocumentRequestSteps extends Component {
  constructor(props) {
    super(props);

    const { docReq } = props;
    const {
      state: currentState,
      document_pid: documentPid,
      physical_item_provider: provider,
    } = docReq;

    const computedStep = getCurrentStep(
      currentState,
      documentPid,
      _get(provider, "pid")
    );

    // If request is already completed (accepted or declined), force to step 2
    const initialStep =
      currentState === "ACCEPTED" || currentState === "DECLINED"
        ? 2
        : computedStep;

    this.state = {
      activeStep: initialStep,
      prevDocReqState: currentState,
      prevDocumentPid: documentPid,
      prevProviderPid: _get(provider, "pid"),
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { docReq } = nextProps;
    const {
      state: currentState,
      document_pid: documentPid,
      physical_item_provider: provider,
    } = docReq;

    const currentProviderPid = _get(provider, "pid");

    if (
      prevState.prevDocReqState !== currentState ||
      prevState.prevDocumentPid !== documentPid ||
      prevState.prevProviderPid !== currentProviderPid
    ) {
      const computedStep = getCurrentStep(
        currentState,
        documentPid,
        currentProviderPid
      );

      // Force activeStep to completed when request is accepted or declined
      if (currentState === "ACCEPTED" || currentState === "DECLINED") {
        return {
          activeStep: 2, // Force to Completed step
          prevDocReqState: currentState,
          prevDocumentPid: documentPid,
          prevProviderPid: currentProviderPid,
        };
      }

      if (computedStep !== prevState.activeStep) {
        return {
          activeStep: computedStep,
          prevDocReqState: currentState,
          prevDocumentPid: documentPid,
          prevProviderPid: currentProviderPid,
        };
      }

      return {
        prevDocReqState: currentState,
        prevDocumentPid: documentPid,
        prevProviderPid: currentProviderPid,
      };
    }

    return null;
  }

  handleStepClick = (stepIndex) => {
    const { docReq } = this.props;
    const { document_pid: documentPid, state } = docReq;

    let canNavigate = false;

    switch (stepIndex) {
      case 0: // Select Document
        // Can access if request is still pending
        canNavigate = state === "PENDING";
        break;
      case 1: // Accept
        // Can only go to accept if document is selected AND request is pending
        canNavigate = !!documentPid && state === "PENDING";
        break;
      case 2: // Completed
        // Can only view completed if request is actually completed
        canNavigate = state === "ACCEPTED" || state === "DECLINED";
        break;
      default:
        canNavigate = false;
    }

    if (canNavigate) {
      this.setState({ activeStep: stepIndex });
    }
  };

  isStepAccessible = (stepIndex) => {
    const { docReq } = this.props;
    const { document_pid: documentPid, state } = docReq;

    switch (stepIndex) {
      case 0: // Select Document
        // Only accessible if request is still pending
        return state === "PENDING";
      case 1: // Accept
        // Only accessible if document is selected AND request is pending
        return !!documentPid && state === "PENDING";
      case 2: // Completed
        // Only accessible if request has been accepted or declined
        return state === "ACCEPTED" || state === "DECLINED";
      default:
        return false;
    }
  };

  render() {
    const { docReq } = this.props;
    const { activeStep } = this.state;
    const {
      state: currentState,
      document_pid: documentPid,
      physical_item_provider: provider,
    } = docReq;

    const computedStep = getCurrentStep(
      currentState,
      documentPid,
      _get(provider, "pid")
    );

    return (
      <>
        <DocumentRequestStepsHeader
          docReq={docReq}
          currentStep={computedStep}
          activeStep={activeStep}
          onStepClick={this.handleStepClick}
          isStepAccessible={this.isStepAccessible}
        />
        <Segment placeholder>
          <DocumentRequestStepPanels docReq={docReq} currentStep={activeStep} />
        </Segment>
      </>
    );
  }
}

DocumentRequestSteps.propTypes = {
  docReq: PropTypes.object.isRequired,
};
